module.exports = __webpack_public_path__ + "img/mpeg.0e4c2613.png";